import app from './en-US/app';
import form from './en-US/form';
import toast from './en-US/toast';
import btn from './en-US/btn';

export default {
  ...app,
  ...form,
  ...toast,
  ...btn,
};
